import { render, staticRenderFns } from "./expiration.vue?vue&type=template&id=6f20cea7&scoped=true"
import script from "./expiration.vue?vue&type=script&lang=js"
export * from "./expiration.vue?vue&type=script&lang=js"
import style0 from "./expiration.vue?vue&type=style&index=0&id=6f20cea7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f20cea7",
  null
  
)

export default component.exports